import { useState } from "react";
import { QrCode } from "lucide-react";
import QRScannerModal from "@/components/QRScannerModal";

/** Floating action button — visible on mobile + tablet on every authenticated
 * page. One tap to open the scanner. */
export default function ScanFAB() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="vb-scan-fab"
        aria-label="Scan QR label"
        data-testid="scan-fab"
      >
        <QrCode size={26} />
      </button>
      {open && <QRScannerModal onClose={() => setOpen(false)} />}
    </>
  );
}
